import { render } from "./sectionh.vue?vue&type=template&id=46729c38"
import script from "./sectionh.vue?vue&type=script&lang=js"
export * from "./sectionh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__